import { Accordion, SimpleGrid, Stack, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { FaAngleDown } from "react-icons/fa6";

import { SectionTitle } from "@/components/general/section-title/section-title";

import { Section } from "../../../general/section/section";
import styles from "./faq-section.module.css";

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQCategory {
    title: string;
    items: FAQItem[];
}

export const FAQSection = () => {
    const { t } = useTranslation();
    const faqGroups = t("home.faq.groups", { returnObjects: true }) as FAQCategory[];
    return (
        <Section variant="blue-cyan">
            <div className={styles.container}>
                <Stack gap="xl" align="center">
                    <SectionTitle title={t("home.faq.title")} subTitle={t("home.faq.subtitle")} />

                    {/* FAQ Categories - Two Column Layout */}
                    <SimpleGrid cols={{ base: 1, md: 2 }} spacing="xl" w="100%">
                        {Array.isArray(faqGroups) &&
                            faqGroups.map((category) => (
                                <div className={styles.categoryBlock} key={category.title}>
                                    <Title order={3} className={styles.categoryTitle}>
                                        {category.title}
                                    </Title>
                                    <Accordion
                                        variant="separated"
                                        chevron={<FaAngleDown size={18} />}
                                        classNames={{
                                            root: styles.accordionRoot,
                                            item: styles.accordionItem,
                                            control: styles.accordionControl,
                                            chevron: styles.accordionChevron,
                                            label: styles.accordionLabel,
                                            panel: styles.accordionPanel,
                                            content: styles.accordionContent,
                                        }}>
                                        {category.items.map((item, itemIndex) => (
                                            <Accordion.Item key={itemIndex as any} value={`${category.title}-${itemIndex}`}>
                                                <Accordion.Control>{item.question}</Accordion.Control>
                                                <Accordion.Panel>{item.answer}</Accordion.Panel>
                                            </Accordion.Item>
                                        ))}
                                    </Accordion>
                                </div>
                            ))}
                    </SimpleGrid>
                </Stack>
            </div>
        </Section>
    );
};
